import React, { FC, useEffect, useState } from "react";
import Accordion from "devextreme-react/accordion";
import dxAccordion from "devextreme/ui/accordion";
import axios from "axios";
import { LoadPanel } from "devextreme-react/load-panel";
import NcdcCatalogContent from "./NcdcCatalogContent";
import ShineCatalogContent from "./ShineCatalogContent";
import { DataCatalogModel } from "../model/FileInterface";
import { useNavigate } from "react-router-dom";
import { handleError } from "../error/ErrorHandler";
import moment from 'moment';
import { TextBox } from 'devextreme-react/text-box';
import { Button } from 'devextreme-react/button';

type Props = {
    hasEditAuth: boolean;
    site: string;
}

const DataCatalog: FC<Props> = ({ hasEditAuth, site }) => {
    const [loading, setLoading] = useState(true);
    const [catalog, setCatalog] = useState<DataCatalogModel[]>([]);
    const [catalogCopy, setCatalogCopy] = useState<DataCatalogModel[]>([]);
    const [searchBoxVal, setSearchBoxVal] = useState('');

    const clickSearchBtn = () => {
        getFilteredCatalogData(searchBoxVal);
    }

    const onSearchValChanged = (e: any) => {
        const newValue = e.value;
        getFilteredCatalogData(newValue);
        setSearchBoxVal(newValue);
    }

    const getFilteredCatalogData = (searchBoxVal: string) => {
        if (searchBoxVal == '') setCatalogCopy(catalog);
        else {
            let filteredResult = catalog.filter(function (item) {
                return (item.catalogDescLrg?.includes(searchBoxVal)) ||
                    (item.catalogDescSml?.includes(searchBoxVal)) ||
                    (item.cstmNm?.includes(searchBoxVal)) ||
                    (item.loadDtm?.includes(searchBoxVal))
            });
            setCatalogCopy(filteredResult);
        }
    }
    const navigate = useNavigate();

    const deleteCatalog = async (target: DataCatalogModel) => {
        if (!window.confirm("해당 카탈로그를 삭제하시겠습니까?")) return;
        setLoading(true);
        try {
            const res = await axios.delete(`/api/catalog/${target.catalogId}`);
            if (res.status !== 200) return;
            const idx = catalog.findIndex((c: DataCatalogModel) => c.catalogId === target.catalogId);
            setCatalog([...catalog.slice(0, idx), ...catalog.slice(idx + 1)]);
        } catch (err) {
            handleError(err);
        } finally {
            setLoading(false);
        }
    };

    const editCategory = (data: DataCatalogModel) => {
        navigate(`/catalog/edit/${data.catalogId}`);
    };

    const addCatalog = () => {
        navigate('/catalog/edit');
    };

    const getCatalog = async () => {
        try {
            const res = await axios.get('/api/catalog/all');
            if (res.data) {
                setCatalog(res.data);
                setCatalogCopy(res.data);
                setLoading(false);
            }
        } catch (err) {
            handleError(err);
        }
    };

    const CustomTitle = (data: DataCatalogModel) => {
        return (
            <div>
                <div className="data-catalog-title">{data.catalogDescSml}</div>
                <div className="data-catalog-desc">{data.catalogDescLrg}</div>
                <div className="data-catalog-etc">
                    <div className="hospital-label">{data.cstmNm}</div>
                    <div className="data-loaddtm">{moment(data.loadDtm).format('YYYY-MM-DD')}</div>
                </div>
            </div>
        )
    }

    const CustomItem = (data: DataCatalogModel) => {
        return (
            <div>
                {site === 'ncdc' ? <NcdcCatalogContent/>
                    : <ShineCatalogContent
                        data={data}/>
                }
                {hasEditAuth &&
                <div className="flex-center">
                    <div>
                        <button className={'catalog-edit-btn'} onClick={() => deleteCatalog(data)}>삭제</button>
                        <button className={'catalog-edit-btn'} onClick={() => editCategory(data)}>수정</button>
                    </div>
                </div>
                }
            </div>
        )
    }

    useEffect(() => {
        getCatalog();
        dxAccordion.defaultOptions({
            options: {
                selectedIndex: -1
            }
        })
        return () => setLoading(false);
    }, []);

    return (
        <div className={'data-catalog-wrapper'}>
            {loading &&
                <LoadPanel visible={true}/>
            }
            {!loading &&
            <>
                <div className={'data-catalog-content'}>
                    <div className={'dx-fieldset'}>
                        <div className="dx-field">
                            <div className="dx-field-value dx-field-value-static input-location">
                                <TextBox showClearButton={true} mode={'search'} className={'dx-texteditor-search'}
                                         placeholder={'검색어 입력후 엔터를 눌러주세요.'}
                                         onValueChanged={onSearchValChanged}/>
                                <Button icon="check"
                                        id="icon-back"
                                        onClick={clickSearchBtn}/>
                            </div>
                        </div>
                    </div>
                    <div className={'w-100'}>
                        {hasEditAuth &&
                        <div className={'flex-end mb-10'}>
                            <button className='add-catalog-btn' onClick={addCatalog}>
                                추가 등록
                            </button>
                        </div>
                        }
                        <Accordion width={'100%'}
                                   dataSource={catalogCopy}
                                   collapsible={true}
                                   itemTitleRender={CustomTitle}
                                   itemRender={CustomItem}/>
                    </div>
                </div>
            </>
            }
        </div>
    );
}

export default DataCatalog;
